import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { LEGAL_PRIVACY_VERSION } from '../../constants';

const Privacy: React.FC = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 760, mx: 'auto', py: { xs: 3, sm: 5 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
        Privacy Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Effective version: {LEGAL_PRIVACY_VERSION}
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>1. Information We Collect</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We collect account information you provide (such as name, email, major, and profile details), and technical data needed to operate securely
        (such as sign-in events and IP addresses for security and legal records).
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>2. How We Use Information</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We use your information to provide core app functionality, maintain account security, and improve reliability. We do not run ad targeting features in this project.
      </Typography>

      <Typography variant="h6" gutterBottom id="contact-info" sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>3. Contact Information from Others</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        In some cases, another user may share your contact details through normal platform usage (for example, profile references or direct interactions).
        You can request correction or removal through support.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>4. Sharing</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We do not sell personal information. We only share data when required for core service operation, legal compliance, or user safety.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>5. Retention</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        We retain data only as long as needed for account operation, legal obligations, fraud prevention, and security.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ fontWeight: 800, letterSpacing: '-0.01em', color: 'primary.main' }}>6. Your Choices</Typography>
      <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
        You can update profile information in-app. You can also manage optional cookie preferences through Cookie Settings.
      </Typography>
    </Box>
  );
};

export default Privacy;
